import { render, staticRenderFns } from "./GSwitch.vue?vue&type=template&id=cffb5396&scoped=true"
import script from "./GSwitch.vue?vue&type=script&lang=js"
export * from "./GSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cffb5396",
  null
  
)

export default component.exports